// store/snackbarSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SnackbarState {
  message: string;
  type: 'success' | 'failure' | 'normal';
  open: boolean;
}

const initialState: SnackbarState = {
  message: '',
  type: 'normal',
  open: false,
};

export const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    showSnackbar: (state, action: PayloadAction<{ message: string; type?: 'success' | 'failure' | 'normal' }>) => {
      state.message = action.payload.message;
      state.type = action.payload.type ?? 'normal';
      state.open = true;
    },
    hideSnackbar: (state) => {
      state.open = false;
    },
  },
});

export const { showSnackbar, hideSnackbar } = snackbarSlice.actions;
export default snackbarSlice.reducer;
